module.exports = __webpack_public_path__ + "static/28-d9e67f412cdf965b7188508af12d5f78.png";